import { render } from "./LoginBtn.vue?vue&type=template&id=bc7091d0&scoped=true"
import script from "./LoginBtn.vue?vue&type=script&lang=js"
export * from "./LoginBtn.vue?vue&type=script&lang=js"

import "./LoginBtn.vue?vue&type=style&index=0&id=bc7091d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7091d0"]])

export default __exports__